import { Font } from '@react-pdf/renderer';

import notoSansRegular from '@/assets/fonts/noto-sans/NotoSansSC-Regular.ttf';
import openSansBold from '@/assets/fonts/Open_Sans/static/OpenSans-Bold.ttf';
import openSansBoldItalic from '@/assets/fonts/Open_Sans/static/OpenSans-BoldItalic.ttf';
import openSansExtraBold from '@/assets/fonts/Open_Sans/static/OpenSans-ExtraBold.ttf';
import openSansExtraBoldItalic from '@/assets/fonts/Open_Sans/static/OpenSans-ExtraBoldItalic.ttf';
import openSansRItalic from '@/assets/fonts/Open_Sans/static/OpenSans-Italic.ttf';
import openSansLight from '@/assets/fonts/Open_Sans/static/OpenSans-Light.ttf';
import openSansLightItalic from '@/assets/fonts/Open_Sans/static/OpenSans-LightItalic.ttf';
import openSansMedium from '@/assets/fonts/Open_Sans/static/OpenSans-Medium.ttf';
import openSansMediumItalic from '@/assets/fonts/Open_Sans/static/OpenSans-MediumItalic.ttf';
import openSansRegular from '@/assets/fonts/Open_Sans/static/OpenSans-Regular.ttf';
import openSansSemiBold from '@/assets/fonts/Open_Sans/static/OpenSans-SemiBold.ttf';
import openSansSemiBoldItalic from '@/assets/fonts/Open_Sans/static/OpenSans-SemiBoldItalic.ttf';

Font.register({
  family: 'Open Sans',
  fonts: [
    {
      src: openSansRegular,
    },
    {
      fontWeight: 200,
      src: openSansLight,
    },
    {
      fontWeight: 400,
      src: openSansRegular,
    },
    {
      fontWeight: 500,
      src: openSansMedium,
    },
    {
      fontWeight: 600,
      src: openSansSemiBold,
    },
    {
      fontWeight: 700,
      src: openSansBold,
    },
    {
      fontWeight: 800,
      src: openSansExtraBold,
    },
  ],
});

Font.register({
  family: 'Open Sans Italic',
  fonts: [
    {
      src: openSansRItalic,
    },
    {
      fontWeight: 200,
      src: openSansLightItalic,
    },
    {
      fontWeight: 400,
      src: openSansRItalic,
    },
    {
      fontWeight: 500,
      src: openSansMediumItalic,
    },
    {
      fontWeight: 600,
      src: openSansSemiBoldItalic,
    },
    {
      fontWeight: 700,
      src: openSansBoldItalic,
    },
    {
      fontWeight: 800,
      src: openSansExtraBoldItalic,
    },
  ],
});

Font.register({
  family: 'Noto Sans',
  fonts: [
    {
      fontWeight: 400,
      src: notoSansRegular,
    },
  ],
});

// preload font
Font.load({ fontFamily: 'Noto Sans' }).catch((err) => {
  console.error('Failed to preload Noto Sans PDF fonts', err);
});

Font.registerHyphenationCallback((word) => {
  // Allow breaking between every character for CJK
  if (/[\u4E00-\u9FFF]/.test(word)) {
    return word.split('');
  }

  // Default behavior for latin
  return [word];
});
